import React from 'react';
import { CoreForumNodeCreator } from '../core/CoreForumNodeCreator';

/**
 * StickerNodeCreator - ForumSticker 专用的节点创建组件包装器
 * @param {Function} props.buildGroupContext - 从页面传递的 context 构建函数
 * @param {string} props.mode - 模式标识
 * @param {string} props.activityId - 活動 ID（可選）
 * @param {string} props.groupId - 群組 ID（可選）
 * @param {string} props.nodeId - 節點 ID（可選）
 */
export const StickerNodeCreator = ({ 
  open, 
  onClose, 
  ws, 
  nodePlan, 
  graphNodes,
  graphEdges, // 新增：接收 edges
  buildGroupContext,
  mode = 'sticker',
  activityId, // ✅ 新增參數
  groupId, // ✅ 新增參數
  nodeId // ✅ 新增參數
}) => {
  return (
    <CoreForumNodeCreator
      open={open}
      onClose={onClose}
      ws={ws}
      nodePlan={nodePlan}
      graphNodes={graphNodes}
      graphEdges={graphEdges} // 传递 edges
      buildGroupContext={buildGroupContext}
      mode={mode}
      activityId={activityId} // ✅ 傳遞參數
      groupId={groupId} // ✅ 傳遞參數
      nodeId={nodeId} // ✅ 傳遞參數
    />
  );
};